// extracted by mini-css-extract-plugin
export var attachment = "_ry-a";
export var emailContainer = "_ry-4";
export var emailContentPaddedContainer = "_ry-b";
export var emailHeader = "_ry-6";
export var emailIframe = "_ry-3";
export var emailInfoIcon = "_ry-9";
export var emailShortenedSummary = "_ry-e";
export var infoDropdown = "_ry-0";
export var infoRowBoundedContent = "_ry-d";
export var internal = "_ry-5";
export var merchant = "_ry-8";
export var messageInputContainer = "_ry-h";
export var normal = "_ry-7";
export var replyCard = "_ry-f";
export var subtleButton = "_ry-1";
export var subtleButtonIconContainer = "_ry-2";
export var toggleViewRepliesButton = "_ry-c";
export var wrappingText = "_ry-g";